import UserContext from "components/contexts/UserContext";
import React, { useContext } from "react";
import { Navigate } from "react-router";

export const RequireAuth = ({ children, redirectTo }) => {
  const { isAuthed } = useContext(UserContext);
  return isAuthed ? children : <Navigate to={redirectTo} replace />;
};
